import { useCallback, useEffect, useState } from "react";
import { downloadDocumentByStoredId } from "services/documentsAPI";
import { usePlateformeTheme } from "shared/contexts/app-init";

export const useMenuLogo = () => {
  const theme = usePlateformeTheme()
  const [logo, setLogo] = useState<string | null>(null);

  const getLogoImg = useCallback(async () => {
    if (theme && theme.logoFileId) {
      const logoBlob = await downloadDocumentByStoredId(theme.logoFileId);
      const logo = URL.createObjectURL(logoBlob);
      setLogo(logo);
    } else {
      setLogo("");
    }
  }, [theme]);

  useEffect(() => {
    getLogoImg();
  }, [theme, getLogoImg]);

  return {
    logo
  }
}
